module.exports = __webpack_public_path__ + "static/media/phone_book_letter.24176b73.png";